<div class="flex flex-col p-6" *ngIf="vm$ | async as vm">
	<div class="flex justify-center">
		<img
			class="w-1/5"
			src="/assets/images/leap/matter-lawyer-clerk-mapping.png"
			alt="Matter lawyer or clerk alert"
		/>
	</div>
	<div class="flex justify-center mt-8">
		<h1 class="text-3xl font-medium">
			The Lawyer in LEAP and Closer do not match
		</h1>
	</div>
	<div class="flex justify-center">
		<ui-section class="h-full w-2/5" title="Lawyer" type="section">
			<div
				section-content
				class="grid grid-rows-fit-content grid-cols-[1fr_4fr] gap-y-4 gap-x-5"
			>
				<div class="text-sm font-medium">LEAP</div>
				<div class="text-sm">{{ vm.leapLawyerName }}</div>

				<div class="text-sm font-medium">Closer</div>
				<div class="text-sm">{{ vm.closerLawyerName }}</div>
			</div>
		</ui-section>
	</div>
	<div class="flex justify-center mt-4">
		The lawyer cannot be changed in Closer as this matter contains a Sync or LLC
		mortgage. Please update the LEAP lawyer.
	</div>
	<div class="flex justify-center mt-8">
		<ui-button
			preset="HIGH_EMPHASIS"
			label="Continue"
			(click)="closeDialog()"
		></ui-button>
	</div>
</div>
